export const categoryListTypes = {
  categoryType: {
    keywordRule: 'keywordRule',
    customRule: 'customRule',
    lineItems: 'lineItems',
    referenceList: 'referenceList',
  },
};
